<template lang="pug">
f7-page#sign-up-done
  navbar(title="新規登録")

  background-image
    .sign-up-done-body
      p.title メールをご確認ください
      p.mail-address {{ email }}
      .done-message
        p 登録されたメールアドレスあてに、認証メールを送信しました。
        p メールに記載されたURLにアクセスして、メールアドレスの認証を行ってください。
        br/
        p 認証用のURLの有効期限は送信後24時間です。
        p メールアドレスに誤りがあった場合は、再度はじめからお手続きをお願いいたします。
      .sign-up-done-footer
        large-button(
          title="OK"
          @click="onClickOk")
</template>

<style lang="scss" scoped>
p {
  margin: 0;
}
.sign-up-done-body {
  padding: 0 16px;

  .title {
    @extend %headline-detail-text;
    margin-top: 48px;
  }

  .mail-address {
    @extend %headline-lists-text;
    height: 64px;
    line-height: 64px;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 0.1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    text-align: center;
    margin: 32px 0 24px;
  }

  .done-message {
    @extend %body-text;
  }

  .sign-up-done-footer {
    position: absolute;
    left: 0;
    bottom: 32px;
    width: 100%;
  }
}
</style>

<script>
import { mapGetters } from 'vuex'
import BridgeSwift from '@/components/mixins/BridgeSwift'
import LargeButton from '@/components/atoms/LargeButton'

export default {
  components: { LargeButton },
  computed: mapGetters('signUp', ['email']),
  mixins: [BridgeSwift],
  methods: {
    onClickOk() {
      this.postMessageToSwift('didTapSignUpDoneOk')
    },
  },
}
</script>
